import React from 'react';

const UnlinkIcon = class extends React.Component {
	render() {
		return (
			<svg fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg" viewBox="2 2 30 30" style={this.props.style||{}}>
				<path d="M16.5,20a.49408.49408,0,0,1-.36688-.16626L21,14.9668V15.5A4.5,4.5,0,0,1,16.5,20Zm7.42407-7.95728L23,12.9668V14.5a.5.5,0,0,0,.5.5A1.5,1.5,0,0,1,25,16.5v4A1.5,1.5,0,0,1,23.5,22h-8a1.49341,1.49341,0,0,1-1.07568-.45752L12.303,23.66382A4.48338,4.48338,0,0,0,15.5,25h8A4.5,4.5,0,0,0,28,20.5v-4A4.48479,4.48479,0,0,0,23.92407,12.04272Zm3.29077-6.98217L5.06055,27.21484a1.49984,1.49984,0,0,1-2.1211-2.12109l5.13648-5.13647A4.48479,4.48479,0,0,1,4,15.5v-4A4.5,4.5,0,0,1,8.5,7h8a4.43773,4.43773,0,0,1,3.18079,1.35242l5.413-5.413a1.49984,1.49984,0,0,1,2.12109,2.1211Zm-9.63916,5.397A1.49341,1.49341,0,0,0,16.5,10h-8A1.5,1.5,0,0,0,7,11.5v4A1.5,1.5,0,0,0,8.5,17a.5.5,0,0,1,.5.5v1.5332l2-2V16.5A4.5,4.5,0,0,1,15.5,12a.49421.49421,0,0,1,.36694.16626Z"/>
			</svg>
		);
	}
}

export default UnlinkIcon;